// Check the major version coming from API calls. If we detect a mismatch, show a warning confirmation to
// reload the application after 5 to 60 seconds later
const src = document
  .querySelector('script[src$="/aware.js"][src*="static.schoolobjects.com"]')
  ?.getAttribute('src');
const version = src?.match(/\/([0-9]+)\/aware/)?.[1];

let notifTriggered = false;

const isEnabledForURL = url => /\/aware\/|\/awarev2\//i.test(url); // enable for Aware, but not Online Testing (which uses /aware2)

const promptUser = () => {
  // Temporarily disabled until we confirm back end deployment major version bump
  return; // eslint-disable-next-line
  if (
    // eslint-disable-next-line
    confirm(
      'This application is out of date. Click OK to reload the page, or Cancel to save your work first.'
    )
  ) {
    document.location.reload();
  } else {
    // retry in 30 seconds
    setTimeout(promptUser, 30_000);
  }
};

export const confirmAPIVersion = headers => {
  const headerVersion = headers?.get('X-Required-Frontend-Version');

  if (
    !notifTriggered &&
    headerVersion &&
    version &&
    isEnabledForURL(document.location.pathname) &&
    headerVersion !== version
  ) {
    notifTriggered = setTimeout(promptUser, (5 + Math.random() * 55) * 1000);
  }
};
